(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fineHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var $ = function (sel, scope) { return (scope || document).querySelector(sel); };
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };
  function safe(fn, name) { try { fn(); } catch (e) { console.warn("[atx:" + name + "]", e); } }

  // Shopify puede "perder" un artículo si se lanzan dos peticiones de
  // carrito (add/change) a la vez desde la misma sesión — es una condición
  // de carrera real del propio carrito, no de este tema. Como ahora el
  // carrito se abre solo y ofrece añadir más cosas al momento, es fácil que
  // el cliente pulse "añadir" dos veces seguidas (producto + oferta del
  // carrito) antes de que la primera petición termine. Esta cola obliga a
  // que todas las peticiones de carrito de este archivo se ejecuten en fila,
  // nunca en paralelo, para que ninguna pise a la otra.
  var atxCartQueue = Promise.resolve();
  function atxQueueCartTask(taskFn) {
    var result = atxCartQueue.then(taskFn);
    // Si esta tarea falla, no debe bloquear la cola para las siguientes.
    atxCartQueue = result.catch(function () {});
    return result;
  }

  function initPopup() {
    var overlay = $("[data-atx-popup-overlay]");
    if (!overlay || overlay.dataset.atxBound) return;
    overlay.dataset.atxBound = "1";

    var STORAGE_KEY = "atx_popup_seen_v1";
    var posted = overlay.dataset.atxPosted === "true";
    var alreadySeen = false;
    try { alreadySeen = !!window.localStorage.getItem(STORAGE_KEY); } catch (e) {}

    var delay = parseInt(overlay.dataset.atxDelay || "2000", 10);
    var closeEls = $$("[data-atx-popup-close]", overlay);
    // Hay más de un botón que abre el popup (el enlace del texto del hero Y
    // la píldora flotante "🎁 -15%"), así que hay que engancharlos todos —
    // antes solo se cogía el primero que encontraba en la página.
    var triggers = $$("[data-atx-popup-trigger]");
    var stepOffer = overlay.querySelector('[data-atx-popup-step="offer"]');
    var stepSuccess = overlay.querySelector('[data-atx-popup-step="success"]');

    function remember() {
      try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch (e) {}
    }

    function open() {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add("is-visible"); });
      document.body.style.overflow = "hidden";
      triggers.forEach(function (t) { t.hidden = true; });
    }

    function close() {
      overlay.classList.remove("is-visible");
      document.body.style.overflow = "";
      remember();
      triggers.forEach(function (t) { t.hidden = false; });
      setTimeout(function () { overlay.hidden = true; }, 400);
    }

    closeEls.forEach(function (el) { el.addEventListener("click", close); });
    overlay.addEventListener("mousedown", function (e) { if (e.target === overlay) close(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("is-visible")) close();
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        if (!posted) {
          if (stepSuccess) stepSuccess.hidden = true;
          if (stepOffer) stepOffer.hidden = false;
        }
        open();
      });
    });

    if (posted) {
      remember();
      open();
    } else if (!alreadySeen) {
      var triggered = false;
      function fireOnce() {
        if (triggered) return;
        triggered = true;
        open();
      }
      // Lo que ocurra antes gana: a los `delay` segundos (10s por defecto,
      // en todos los dispositivos) o, en escritorio, en cuanto se detecta
      // intento real de salida (el ratón sale por arriba de la ventana).
      setTimeout(fireOnce, delay);
      if (fineHover) {
        var armed = false;
        setTimeout(function () { armed = true; }, 2000); // margen para no disparar nada más cargar
        document.addEventListener("mouseout", function onExitIntent(e) {
          if (armed && e.clientY <= 0) {
            document.removeEventListener("mouseout", onExitIntent);
            fireOnce();
          }
        });
      }
    }
  }

  function initScrollProgress() {
    var bar = $("[data-atx-scroll-progress]");
    if (!bar || bar.dataset.atxBound) return;
    bar.dataset.atxBound = "1";
    var raf = null;
    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = "scaleX(" + Math.min(1, Math.max(0, pct)) + ")";
      raf = null;
    }
    window.addEventListener("scroll", function () {
      if (!raf) raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initReveals() {
    var els = $$("[data-atx-reveal], [data-atx-reveal-stagger]");
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: "0px 0px -2% 0px" });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains("is-visible") && el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add("is-visible");
        }
      });
    }, 6000);
  }

  function initTilt() {
    if (!fineHover) return;
    $$(".atx-has-tilt").forEach(function (card) {
      if (card.dataset.atxTiltBound) return;
      card.dataset.atxTiltBound = "1";
      var MAX = 6, tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        tx = -py * MAX; ty = px * MAX;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      card.addEventListener("mouseleave", function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop); });
      function loop() {
        cx += (tx - cx) * 0.15; cy += (ty - cy) * 0.15;
        card.style.setProperty("--rx", cx.toFixed(2) + "deg");
        card.style.setProperty("--ry", cy.toFixed(2) + "deg");
        raf = (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) ? requestAnimationFrame(loop) : null;
      }
    });
  }

  function initMagnetic() {
    if (!fineHover) return;
    $$("[data-atx-magnetic]").forEach(function (el) {
      if (el.dataset.atxMagBound) return;
      el.dataset.atxMagBound = "1";
      var strength = parseFloat(el.dataset.atxMagnetic || "0.25");
      var raf = null, pendingX = 0, pendingY = 0;
      function applyTransform() {
        el.style.transform = "translate3d(" + pendingX + "px," + pendingY + "px,0)";
        raf = null;
      }
      el.addEventListener("mousemove", function (e) {
        // Solo se LEE el layout aquí (getBoundingClientRect); la escritura del
        // estilo se difiere a un requestAnimationFrame para no forzar un reflow
        // síncrono en cada píxel de movimiento del ratón.
        var r = el.getBoundingClientRect();
        pendingX = (e.clientX - r.left - r.width / 2) * strength;
        pendingY = (e.clientY - r.top - r.height / 2) * strength;
        if (!raf) raf = requestAnimationFrame(applyTransform);
      });
      el.addEventListener("mouseleave", function () {
        pendingX = 0; pendingY = 0;
        if (!raf) raf = requestAnimationFrame(applyTransform);
      });
    });
  }

  function initCountUp() {
    var finalValue = function (el) {
      var raw = el.dataset.countTo; var decimals = (raw.split(".")[1] || "").length;
      return parseFloat(raw).toFixed(decimals) + (el.dataset.countSuffix || "");
    };
    $$("[data-count-to]").forEach(function (el) {
      if (el.dataset.atxCountBound) return;
      el.dataset.atxCountBound = "1";
      var target = parseFloat(el.dataset.countTo);
      var decimals = (el.dataset.countTo.split(".")[1] || "").length;
      var suffix = el.dataset.countSuffix || "";
      var trigger = function () {
        if (el.dataset.counted) return;
        var start = null, duration = reduced ? 400 : 1300;
        var forceFinish = setTimeout(function () {
          if (!el.dataset.counted) { el.dataset.counted = "1"; el.textContent = finalValue(el); }
        }, duration + 400);
        function step(ts) {
          if (el.dataset.counted) return;
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else { el.dataset.counted = "1"; clearTimeout(forceFinish); }
        }
        requestAnimationFrame(step);
      };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { trigger(); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      io.observe(el);
    });
    setTimeout(function () {
      $$("[data-count-to]").forEach(function (el) {
        if (!el.dataset.counted && el.getBoundingClientRect().top < window.innerHeight) {
          el.dataset.counted = "1"; el.textContent = finalValue(el);
        }
      });
    }, 6000);
  }

  // Galería de producto: clic en miniatura cambia la imagen principal
  function initGallery() {
    $$("[data-atx-gallery]").forEach(function (gallery) {
      if (gallery.dataset.atxGalleryBound) return;
      gallery.dataset.atxGalleryBound = "1";
      var main = gallery.querySelector("[data-atx-gallery-main]");
      var thumbs = $$("[data-atx-gallery-thumb]", gallery);
      if (!main || !thumbs.length) return;

      function showThumb(thumb) {
        // Si no quitamos srcset/sizes, el navegador ignora este .src manual
        // y sigue resolviendo la imagen visible contra el srcset original
        // (el de la foto destacada), así que a la vista no cambia nada
        // aunque el atributo .src si se actualice.
        main.removeAttribute("srcset");
        main.removeAttribute("sizes");
        main.src = thumb.dataset.full || thumb.querySelector("img").src;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () { showThumb(thumb); });
      });

      function goTo(step) {
        var activeIndex = thumbs.findIndex(function (t) { return t.classList.contains("is-active"); });
        if (activeIndex === -1) activeIndex = 0;
        var nextIndex = (activeIndex + step + thumbs.length) % thumbs.length;
        showThumb(thumbs[nextIndex]);
      }
      var prevBtn = gallery.querySelector("[data-atx-gallery-prev]");
      var nextBtn = gallery.querySelector("[data-atx-gallery-next]");
      if (prevBtn) prevBtn.addEventListener("click", function () { goTo(-1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { goTo(1); });

      // Deslizar (swipe) sobre la foto principal para pasar a la
      // siguiente/anterior, además de poder tocar las miniaturas.
      var startX = 0, startY = 0, dragging = false;
      main.addEventListener("touchstart", function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragging = true;
      }, { passive: true });
      main.addEventListener("touchend", function (e) {
        if (!dragging) return;
        dragging = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        goTo(dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  // Selector de variantes: Color x Oferta -> localiza la variante real de
  // Shopify, actualiza precio/id/disponibilidad y la imagen del color.
  function initVariantPicker() {
    $$("[data-atx-product-form]").forEach(function (root) {
      if (root.dataset.atxVariantBound) return;
      root.dataset.atxVariantBound = "1";

      var dataEl = root.querySelector("[data-atx-variants-json]");
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var colorEls = $$("[data-atx-color]", root);
      var offerEls = $$("[data-atx-offer]");
      var idInput = root.querySelector("[data-atx-variant-id]");
      // El precio vive FUERA del <form> (es un hermano anterior en el DOM),
      // así que hay que buscarlo en todo el documento, no solo dentro de root.
      var priceNowEls = $$("[data-atx-price-now]");
      var priceWasEls = $$("[data-atx-price-was]");
      var addBtn = root.querySelector("[data-atx-add-btn]");
      var stickyAddBtns = $$("[data-atx-sticky-add]");
      var discountItem = document.querySelector("[data-atx-discount-item]");
      var discountPct = document.querySelector("[data-atx-discount-pct]");
      var galleryImgs = $$("[data-atx-color-image]");
      var sizeError = root.querySelector("[data-atx-size-error]");
      // Algunos productos (p. ej. las plantillas) exigen que el cliente elija
      // talla de forma explícita antes de poder comprar: no basta con el
      // valor por defecto interno usado para calcular precio/pack.
      var requireSize = root.dataset.atxRequireSize === "true";
      // La talla se puede elegir con botones (rodillo) o con un <select>
      // (plantillas, donde además hay varios selectores por par); esta
      // función normaliza cómo se lee el valor elegido en cada caso.
      function isFieldEl(el) {
        return el.tagName === "SELECT" || el.tagName === "INPUT";
      }
      function colorValue(el) {
        if (!el) return null;
        return isFieldEl(el) ? el.value : el.dataset.atxColor;
      }
      var sizeChosenInitially = colorEls.some(function (e) {
        return isFieldEl(e) ? !!e.value : e.classList.contains("is-active");
      });

      var state = {
        color: colorValue(colorEls.find(function (e) { return isFieldEl(e) ? !!e.value : e.classList.contains("is-active"); }) || colorEls[0]),
        offer: (offerEls.find(function (e) { return e.classList.contains("is-active"); }) || offerEls[0] || {}).dataset ? (offerEls.find(function (e) { return e.classList.contains("is-active"); }) || offerEls[0]).dataset.atxOffer : null,
        sizeChosen: !requireSize || sizeChosenInitially
      };

      function money(cents) {
        return (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
      }

      function findVariant() {
        return variants.find(function (v) {
          var opts = {};
          v.options.forEach(function (val, i) { opts[i] = val; });
          return v.option1 === state.color && v.option2 === state.offer;
        });
      }

      // El precio arriba del todo debe reflejar el pack elegido aunque
      // todavía no se haya elegido talla (que es obligatoria para poder
      // comprar, pero no debería "congelar" el precio mostrado en el del
      // primer pack). Como el precio es el mismo para cualquier talla
      // dentro de un mismo pack, vale cualquier variante que tenga ese
      // pack — no hace falta que coincida también la talla.
      function findPreviewVariant() {
        return variants.find(function (v) { return v.option2 === state.offer; });
      }

      function render(isInitialRender) {
        // Esto debe reflejarse siempre, aunque todavía no haya una variante
        // válida (p. ej. falta elegir talla): si no, el pack elegido ni
        // siquiera se ve marcado como seleccionado mientras tanto.
        offerEls.forEach(function (el) { el.classList.toggle("is-active", el.dataset.atxOffer === state.offer); });
        var activeOfferEl2 = offerEls.find(function (el) { return el.dataset.atxOffer === state.offer; });
        if (activeOfferEl2 && activeOfferEl2.dataset.atxOfferPerpair) {
          $$("[data-atx-price-perpair]").forEach(function (el) { el.textContent = money(parseInt(activeOfferEl2.dataset.atxOfferPerpair, 10)); });
        }
        var savingsBanner = document.querySelector("[data-atx-savings-banner]");
        if (savingsBanner && activeOfferEl2) {
          var ahorro = parseInt(activeOfferEl2.dataset.atxOfferAhorro || "0", 10);
          if (ahorro > 0) {
            var amountEl = savingsBanner.querySelector("[data-atx-savings-amount]");
            var pairsEl = savingsBanner.querySelector("[data-atx-savings-pairs]");
            if (amountEl) amountEl.textContent = (ahorro % 100 === 0) ? (ahorro / 100) + " €" : money(ahorro);
            if (pairsEl) pairsEl.textContent = "(vs. comprar " + (activeOfferEl2.dataset.atxOfferPairs || "") + " pares sueltos)";
            savingsBanner.hidden = false;
          } else {
            savingsBanner.hidden = true;
          }
        }
        if (sizeError) sizeError.classList.toggle("is-visible", !state.sizeChosen);
        var v = findVariant();
        var priceVariant = v || findPreviewVariant();
        if (!priceVariant) {
          if (addBtn) addBtn.disabled = true;
          stickyAddBtns.forEach(function (stickyAddBtn) { stickyAddBtn.disabled = true; });
          return;
        }
        if (v && idInput) idInput.value = v.id;
        priceNowEls.forEach(function (el) { el.textContent = money(priceVariant.price); });
        if (offerEls.length && state.offer) {
          var packClean = state.offer.replace(/^\S+\s*/, "");
          $$("[data-atx-sticky-pack]").forEach(function (el) { el.textContent = packClean; });
        }
        // El precio tachado puede venir del campo real de Shopify
        // (compare_at_price) o, en packs con descuento cosmético, del
        // data-atx-offer-was de la tarjeta de pack activa.
        var activeOfferForPrice = offerEls.find(function (el) { return el.dataset.atxOffer === state.offer; });
        var cosmeticWas = activeOfferForPrice ? parseInt(activeOfferForPrice.dataset.atxOfferWas || "0", 10) : 0;
        var effectiveWas = (priceVariant.compare_at_price && priceVariant.compare_at_price > priceVariant.price) ? priceVariant.compare_at_price : cosmeticWas;
        priceWasEls.forEach(function (el) {
          if (effectiveWas > priceVariant.price) {
            el.textContent = money(effectiveWas);
            el.style.display = "";
          } else {
            el.style.display = "none";
          }
        });
        if (discountItem) {
          if (effectiveWas > priceVariant.price) {
            var pct = Math.round(((effectiveWas - priceVariant.price) / effectiveWas) * 100);
            if (discountPct) discountPct.textContent = "Ahorra un " + pct + "%";
            discountItem.style.display = "";
          } else {
            discountItem.style.display = "none";
          }
        }
        var canAdd = !!v && v.available && state.sizeChosen;
        if (addBtn) {
          addBtn.disabled = !canAdd;
          if (v && !v.available) {
            addBtn.textContent = addBtn.dataset.labelSoldOut;
          } else if (!state.sizeChosen && addBtn.dataset.labelSizeMissing) {
            addBtn.textContent = addBtn.dataset.labelSizeMissing;
          } else {
            addBtn.textContent = addBtn.dataset.labelAvailable + " — " + money(priceVariant.price);
          }
        }
        stickyAddBtns.forEach(function (stickyAddBtn) {
          if (v && !v.available) {
            stickyAddBtn.disabled = true;
            stickyAddBtn.dataset.atxNeedsSize = "";
            stickyAddBtn.textContent = addBtn.dataset.labelSoldOut;
          } else if (!state.sizeChosen) {
            // No la deshabilitamos: así se puede tocar para que suba hasta
            // el selector de talla en vez de quedarse muerta en la mano.
            stickyAddBtn.disabled = false;
            stickyAddBtn.dataset.atxNeedsSize = "1";
            stickyAddBtn.textContent = addBtn.dataset.labelSizeMissing || "Elige tu talla";
          } else {
            stickyAddBtn.disabled = false;
            stickyAddBtn.dataset.atxNeedsSize = "";
            stickyAddBtn.textContent = addBtn.dataset.labelAvailable;
          }
        });
        colorEls.forEach(function (el) { el.classList.toggle("is-active", el.dataset.atxColor === state.color); });
        galleryImgs.forEach(function (img) { img.style.display = img.dataset.atxColorImage === state.color ? "" : "none"; });

        // Si el círculo de color tiene una foto real vinculada (subida por el
        // usuario), la ponemos como imagen principal de la galería — pero
        // SOLO cuando el cambio lo dispara un clic real del usuario. En la
        // carga inicial de la página, la imagen principal ya es la correcta
        // (product.featured_image, precargada y con srcset optimizado para
        // móvil); si aquí la sustituyéramos también al cargar, tirábamos ese
        // srcset y forzábamos una segunda descarga de una foto de escritorio
        // (1200px) por encima de la que el navegador ya estaba precargando,
        // duplicando la descarga de la imagen LCP y empeorando el LCP.
        if (!isInitialRender) {
          var activeColorEl = colorEls.find(function (el) { return el.dataset.atxColor === state.color; });
          if (activeColorEl && activeColorEl.dataset.atxColorSwap) {
            var mainImg = document.querySelector("[data-atx-gallery-main]");
            if (mainImg) {
              // La imagen tiene srcset/sizes (para servir el tamaño correcto
              // según el móvil/escritorio). Si no los quitamos, el navegador
              // ignora este .src manual y sigue resolviendo contra el srcset
              // antiguo, y el cambio de color no se ve.
              mainImg.removeAttribute("srcset");
              mainImg.removeAttribute("sizes");
              mainImg.src = activeColorEl.dataset.atxColorSwap;
              if (activeColorEl.dataset.atxColorSwapAlt) mainImg.alt = activeColorEl.dataset.atxColorSwapAlt;
            }
            $$("[data-atx-gallery-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
          }
        }

        // Igual que el swap por color, pero para el pack elegido (p. ej. un
        // pack de varias unidades puede mostrar una foto distinta mostrando
        // el conjunto). Solo tras un clic real, nunca en la carga inicial.
        if (!isInitialRender) {
          var mainImg2 = document.querySelector("[data-atx-gallery-main]");
          var activeOfferEl = offerEls.find(function (el) { return el.dataset.atxOffer === state.offer; });
          if (mainImg2 && !mainImg2.dataset.atxOriginalSrc) {
            mainImg2.dataset.atxOriginalSrc = mainImg2.getAttribute("src") || "";
            mainImg2.dataset.atxOriginalSrcset = mainImg2.getAttribute("srcset") || "";
            mainImg2.dataset.atxOriginalSizes = mainImg2.getAttribute("sizes") || "";
            mainImg2.dataset.atxOriginalAlt = mainImg2.getAttribute("alt") || "";
          }
          if (mainImg2 && activeOfferEl && activeOfferEl.dataset.atxOfferSwap) {
            mainImg2.removeAttribute("srcset");
            mainImg2.removeAttribute("sizes");
            mainImg2.src = activeOfferEl.dataset.atxOfferSwap;
            if (activeOfferEl.dataset.atxOfferSwapAlt) mainImg2.alt = activeOfferEl.dataset.atxOfferSwapAlt;
          } else if (mainImg2 && mainImg2.dataset.atxOriginalSrc && !(activeColorEl && activeColorEl.dataset.atxColorSwap)) {
            // Ningún pack ni color con foto propia seleccionado: recupera la imagen original.
            mainImg2.src = mainImg2.dataset.atxOriginalSrc;
            if (mainImg2.dataset.atxOriginalSrcset) mainImg2.setAttribute("srcset", mainImg2.dataset.atxOriginalSrcset);
            if (mainImg2.dataset.atxOriginalSizes) mainImg2.setAttribute("sizes", mainImg2.dataset.atxOriginalSizes);
            mainImg2.alt = mainImg2.dataset.atxOriginalAlt;
          }
          if (mainImg2 && mainImg2.src) {
            $$("[data-atx-sticky-img]").forEach(function (el) { el.src = mainImg2.src; });
          }
        }
      }

      colorEls.forEach(function (el) {
        var eventName = isFieldEl(el) ? "change" : "click";
        el.addEventListener(eventName, function () { state.color = colorValue(el); state.sizeChosen = !!state.color; render(); });
      });
      offerEls.forEach(function (el) {
        el.addEventListener("click", function () {
          state.offer = el.dataset.atxOffer;
          // Cada pack tiene su propio selector de "talla del par 1" (dentro
          // de su propio bloque de tallas); al cambiar de pack hay que leer
          // el de ESE pack, si no nos quedamos con el valor del pack
          // anterior (o vacío) y la variante nunca llega a encontrarse.
          var colorElForThisOffer = colorEls.find(function (c) {
            var group = c.closest("[data-atx-bundle-sizes]");
            return !group || group.dataset.pack === state.offer;
          });
          state.color = colorValue(colorElForThisOffer) || null;
          state.sizeChosen = !requireSize || !!state.color;
          render();
        });
      });

      render(true);
    });
  }

  // Plantillas: cuando el pack elegido trae varios pares (incluidos los de
  // regalo), deja elegir la talla de cada uno por separado, con una pequeña
  // animación al cambiar de pack, y no deja comprar hasta rellenarlas todas.
  function initBundleSizes() {
    $$("[data-atx-product-form]").forEach(function (root) {
      if (root.dataset.atxBundleSizesBound) return;
      var groups = $$("[data-atx-bundle-sizes]", root);
      if (!groups.length) return;
      root.dataset.atxBundleSizesBound = "1";

      var offerEls = $$("[data-atx-offer]");
      var addBtn = root.querySelector("[data-atx-add-btn]");
      var stickyAddBtns = $$("[data-atx-sticky-add]");
      var sizeError = root.querySelector("[data-atx-size-error]");

      function activeGroup() {
        return groups.find(function (g) { return !g.hidden; });
      }

      function validate() {
        var group = activeGroup();
        var valid = !!group;
        var missing = 0;
        var total = 0;
        if (group) {
          var fields = $$("[data-atx-size-field]", group);
          total = fields.length;
          fields.forEach(function (field) {
            if (!field.value) { valid = false; missing++; }
          });
        }
        if (sizeError) {
          sizeError.classList.toggle("is-visible", !valid);
          var defaultMsg = sizeError.dataset.atxSizeErrorDefault;
          if (!valid) {
            if (defaultMsg) {
              sizeError.textContent = defaultMsg;
            } else if (group) {
              var checkbox = group.querySelector("[data-atx-same-size]");
              if (checkbox && missing === total) {
                sizeError.textContent = checkbox.checked
                  ? "Elige la talla de tus " + total + " pares"
                  : "👆 Elige tu talla arriba";
              } else if (checkbox) {
                sizeError.textContent = missing === 1 ? "Te falta 1 talla por elegir" : "Te faltan " + missing + " tallas por elegir";
              } else {
                sizeError.textContent = "👆 Elige tu talla arriba";
              }
            }
          }
        }
        if (addBtn) {
          addBtn.disabled = !valid;
          var isSoldOut = addBtn.textContent.trim() === (addBtn.dataset.labelSoldOut || "").trim();
          if (!isSoldOut) {
            if (!valid && addBtn.dataset.labelSizeMissing) {
              addBtn.textContent = addBtn.dataset.labelSizeMissing;
            } else if (valid && addBtn.dataset.labelAvailable) {
              var priceNowEl = document.querySelector("[data-atx-price-now]");
              if (priceNowEl) addBtn.textContent = addBtn.dataset.labelAvailable + " — " + priceNowEl.textContent;
            }
          }
        }
        stickyAddBtns.forEach(function (stickyAddBtn) {
          var stickyIsSoldOut = stickyAddBtn.textContent.trim() === (addBtn && addBtn.dataset.labelSoldOut || "").trim();
          if (!stickyIsSoldOut) {
            stickyAddBtn.disabled = false;
            if (!valid) {
              stickyAddBtn.dataset.atxNeedsSize = "1";
              stickyAddBtn.textContent = (addBtn && addBtn.dataset.labelSizeMissing) || "Elige tu talla";
            } else {
              stickyAddBtn.dataset.atxNeedsSize = "";
              stickyAddBtn.textContent = (addBtn && addBtn.dataset.labelAvailable) || "Añadir al carrito";
            }
          }
        });
        return valid;
      }

      function showGroupFor(offerValue) {
        groups.forEach(function (g) {
          var match = g.dataset.pack === offerValue;
          g.hidden = !match;
          // Pequeño respiro para que la animación de aparición se note en
          // vez de aparecer de golpe.
          g.classList.remove("is-animating");
          if (match) {
            requestAnimationFrame(function () {
              g.classList.add("is-animating");
              // Un pequeño destello para que quede clarísimo que este es el
              // bloque que acaba de aparecer al elegir el pack.
              g.classList.remove("is-flash");
              requestAnimationFrame(function () { g.classList.add("is-flash"); });
            });
          }
          g.classList.toggle("is-active", match);
          $$("[data-atx-size-field]", g).forEach(function (field) {
            field.disabled = !match;
            if (!match) {
              field.value = "";
              var pillGroup = field.previousElementSibling;
              if (pillGroup && pillGroup.matches("[data-atx-size-pills]")) {
                $$(".atx-size-pill", pillGroup).forEach(function (btn) { btn.classList.remove("is-active"); });
              }
            }
          });
          // El checkbox "Misma talla para todo el pack" no es un
          // [data-atx-size-field], así que el bucle de arriba no lo toca —
          // sin esto se quedaba "disabled" en cualquier pack que no fuera
          // el activo al cargar la página, y no respondía a los toques
          // reales del cliente (solo a cambios hechos por JavaScript).
          var sameSizeBox = g.querySelector("[data-atx-same-size]");
          if (sameSizeBox) sameSizeBox.disabled = !match;
        });
        validate();
      }

      offerEls.forEach(function (el) {
        el.addEventListener("click", function () { showGroupFor(el.dataset.atxOffer); });
      });
      groups.forEach(function (g) {
        $$("[data-atx-size-field]", g).forEach(function (field) {
          field.addEventListener("change", validate);
        });
      });

      validate();
    });
  }

  // Al elegir la talla del primer par de plantillas, se autorrellenan el
  // resto de selectores de talla del mismo pack con esa misma talla — el
  // cliente puede cambiar cualquiera de ellos después a mano si quiere.
  function initTallaAutofill() {
    $$("[data-atx-bundle-sizes]").forEach(function (group) {
      var source = group.querySelector('[data-atx-fill-source="talla"]');
      var checkbox = group.querySelector('[data-atx-same-size]');
      if (!source || source.dataset.atxFillBound) return;
      source.dataset.atxFillBound = "1";

      var otherRows = $$("[data-atx-size-row]", group);

      function setFieldValue(field, val) {
        field.value = val;
        var pillGroup = field.previousElementSibling;
        if (pillGroup && pillGroup.matches("[data-atx-size-pills]")) {
          $$(".atx-size-pill", pillGroup).forEach(function (btn) {
            btn.classList.toggle("is-active", btn.dataset.value === val);
          });
        }
      }

      function fillAll() {
        var val = source.value;
        if (!val) return;
        $$('[data-atx-fill-target="talla"]', group).forEach(function (target) {
          if (target.value === val) return;
          setFieldValue(target, val);
          target.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      // Con "Misma talla para todo el pack" marcado, solo hace falta elegir
      // el Par 1: el resto de filas se ocultan en vez de quedarse ahí
      // vacías pidiendo lo mismo otra vez. La propia etiqueta del Par 1
      // cambia entre "Elige tu talla" (una sola decisión) y "Talla par 1"
      // (cuando hay varias tallas distintas que elegir).
      function syncRows() {
        if (!checkbox) return;
        otherRows.forEach(function (row) { row.hidden = checkbox.checked; });
        var sourceLabel = source.closest(".atx-bundle-size-row").querySelector("label");
        if (sourceLabel && sourceLabel.dataset.atxSizeLabelSingle) {
          sourceLabel.textContent = checkbox.checked ? sourceLabel.dataset.atxSizeLabelSingle : sourceLabel.dataset.atxSizeLabelMulti;
        }
      }

      // Solo autorrellena el resto de tallas si el cliente ha marcado
      // explícitamente "Todas las tallas iguales" — si no hay checkbox
      // (packs de 1 par pagado + 1 regalo) mantenemos el autorrelleno
      // automático de siempre, ya que ahí solo hay 2 campos.
      source.addEventListener("change", function () {
        if (!checkbox || checkbox.checked) fillAll();
      });
      if (checkbox) {
        checkbox.addEventListener("change", function () {
          if (checkbox.checked) fillAll();
          syncRows();
          source.dispatchEvent(new Event("change", { bubbles: true }));
        });
        syncRows();
      }
    });
  }

  // Botones de talla (pills) que sustituyen al <select> oculto: al pulsar
  // uno, guardan el valor en el input oculto justo después y disparan
  // "change" para que el resto de la lógica (validación, autorrelleno,
  // variante activa) siga funcionando exactamente igual que con un select.
  function initSizePills() {
    $$("[data-atx-size-pills]").forEach(function (group) {
      if (group.dataset.atxPillsBound) return;
      group.dataset.atxPillsBound = "1";
      var field = group.nextElementSibling;
      if (!field || !field.hasAttribute("data-atx-size-field")) return;

      $$(".atx-size-pill", group).forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (field.disabled) return;
          field.value = btn.dataset.value;
          $$(".atx-size-pill", group).forEach(function (b) { b.classList.toggle("is-active", b === btn); });
          field.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  // Modal con la tabla de equivalencias EU/UK/US y la explicación de cómo
  // recortar si el cliente está entre dos tallas.
  function initSizeGuide() {
    $$("[data-atx-size-guide-modal]").forEach(function (modal) {
      if (modal.dataset.atxBound) return;
      modal.dataset.atxBound = "1";
      var openers = $$("[data-atx-size-guide-open]");
      var closers = $$("[data-atx-size-guide-close]", modal);

      function open() { modal.hidden = false; }
      function close() { modal.hidden = true; }

      openers.forEach(function (btn) { btn.addEventListener("click", open); });
      closers.forEach(function (el) { el.addEventListener("click", close); });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !modal.hidden) close();
      });
    });
  }

  function initStickyBuy() {
    var bar = document.querySelector("[data-atx-sticky-buy]");
    var realBtn = document.querySelector("[data-atx-add-btn]");
    if (!bar || !realBtn || bar.dataset.atxBound) return;
    bar.dataset.atxBound = "1";

    var pastButton = false;
    var nearFooter = false;

    function sync() {
      bar.classList.toggle("is-visible", pastButton && !nearFooter);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Solo se muestra cuando el botón real ha quedado por ENCIMA del
        // viewport (el cliente ha scrolleado hacia abajo pasándolo de
        // largo). Si el botón todavía no se ha visto porque está más abajo
        // (p. ej. recién cargada la página, viendo el hero), top > 0 y no
        // se muestra la barra — si no, aparecería desde el primer segundo
        // en páginas donde el botón real no está en la pantalla inicial.
        pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sync();
      });
    }, { threshold: 0 });
    io.observe(realBtn);

    // Se esconde antes de llegar al footer para no taparlo justo cuando el
    // cliente ya ha leído todo y está buscando el resto de enlaces/legal.
    var footer = document.querySelector("footer, .footer, #shopify-section-footer");
    if (footer) {
      var footerIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          nearFooter = entry.isIntersecting;
          sync();
        });
      }, { rootMargin: "0px 0px -10% 0px" });
      footerIo.observe(footer);
    }

    // Si todavía falta elegir talla, tocar el botón sticky sube hasta el
    // selector en vez de intentar enviar el formulario (que fallaría igual).
    $$("[data-atx-sticky-add]").forEach(function (stickyBtn) {
      stickyBtn.addEventListener("click", function (e) {
        if (stickyBtn.dataset.atxNeedsSize === "1") {
          e.preventDefault();
          var target = document.querySelector("[data-atx-bundle-sizes-wrap]") || document.querySelector("[data-atx-size-error]");
          if (target) target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    });
  }

  // Los formularios de compra de plantillas/kit son un {% form 'product' %}
  // normal (no el <product-form> de Dawn), así que sin esto el navegador
  // hacía un envío síncrono y recargaba en /cart en vez de abrir el carrito.
  function initAjaxProductForm() {
    $$("[data-atx-product-form]").forEach(function (form) {
      if (form.dataset.atxAjaxBound) return;
      form.dataset.atxAjaxBound = "1";

      function onSubmit(e) {
        e.preventDefault();
        var submitBtns = $$('[type="submit"]', form).concat(
          $$('[type="submit"][form="' + form.id + '"]')
        );
        submitBtns.forEach(function (b) { b.dataset.atxOriginalText = b.textContent; b.disabled = true; b.textContent = "Añadiendo..."; });

        var cartDrawer = document.querySelector("cart-drawer");
        var formData = new FormData(form);
        if (cartDrawer && cartDrawer.getSectionsToRender) {
          formData.append("sections", cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(","));
          formData.append("sections_url", window.location.pathname);
        }

        atxQueueCartTask(function () {
          return fetch(window.routes.cart_add_url, {
            method: "POST",
            headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
            body: formData,
          })
            .then(function (r) { return r.json(); })
            .then(function (response) {
              if (response.status) {
                throw new Error(response.description || response.message || "No se pudo añadir");
              }
              var renderFinal = function (finalResponse) {
                if (cartDrawer && typeof cartDrawer.renderContents === "function") {
                  // Igual que hace el product-form.js de Dawn: si el carrito
                  // estaba vacío al cargar la página, el propio <cart-drawer>
                  // se renderizó con la clase "is-empty", que oculta el listado
                  // de artículos por CSS. renderContents() solo la quita de
                  // ".drawer__inner" (un hijo), no de este elemento — sin esto
                  // el producto añadido no llegaba a verse aunque sí estuviera
                  // en el carrito.
                  if (cartDrawer.classList.contains("is-empty")) cartDrawer.classList.remove("is-empty");
                  cartDrawer.renderContents(finalResponse);
                } else {
                  window.location.href = window.routes.cart_url;
                }
              };

              // Upsell del Roll justo encima del botón: si el cliente lo
              // marcó, lo añadimos como segunda línea en la misma compra.
              var upsellCheckbox = form.querySelector("[data-atx-product-upsell-check]");
              if (upsellCheckbox && upsellCheckbox.checked && upsellCheckbox.dataset.variantId) {
                var upsellFormData = new FormData();
                upsellFormData.append("id", upsellCheckbox.dataset.variantId);
                upsellFormData.append("quantity", "1");
                if (cartDrawer && cartDrawer.getSectionsToRender) {
                  upsellFormData.append("sections", cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(","));
                  upsellFormData.append("sections_url", window.location.pathname);
                }
                fetch(window.routes.cart_add_url, {
                  method: "POST",
                  headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
                  body: upsellFormData,
                })
                  .then(function (r) { return r.json(); })
                  .then(function (upsellResponse) { renderFinal(upsellResponse.status ? response : upsellResponse); })
                  .catch(function () { renderFinal(response); });
              } else {
                renderFinal(response);
              }
            })
            .catch(function (err) {
              console.warn("[atx:addToCart]", err);
              form.removeEventListener("submit", onSubmit);
              form.submit();
              return;
            })
            .finally(function () {
              submitBtns.forEach(function (b) { b.disabled = false; if (b.dataset.atxOriginalText) b.textContent = b.dataset.atxOriginalText; });
            });
        });
      }

      // El botón sticky vive fuera del <form> pero apunta a él con
      // form="atx-product-form", así que al pulsarlo el navegador dispara
      // el evento "submit" de este mismo form — no hace falta otro listener.
      form.addEventListener("submit", onSubmit);
    });
  }

  function initCartGuard() {
    // La bola de masaje solo debe poder comprarse junto con las plantillas,
    // porque enviada sola sale mucho más cara de preparar. Si alguien quita
    // las plantillas del carrito dejando solo la bola (con o sin rodillo),
    // la retiramos automáticamente.
    if (document.body.dataset.atxGuardBound) return;
    document.body.dataset.atxGuardBound = "1";

    var PLANTILLAS_PRODUCT_ID = 11191549329751;
    var BALL_PRODUCT_ID = 11155062522199;

    if (sessionStorage.getItem("atx_ball_guard_note") === "1") {
      sessionStorage.removeItem("atx_ball_guard_note");
      var note = document.createElement("div");
      note.className = "atx-cart-guard-note";
      note.textContent = "Hemos quitado la bola de masaje del carrito: solo está disponible junto con las plantillas.";
      document.body.appendChild(note);
      setTimeout(function () { note.remove(); }, 5000);
    }

    function enforce() {
      fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasPlantillas = cart.items.some(function (i) { return i.product_id === PLANTILLAS_PRODUCT_ID; });
          var ballItem = cart.items.find(function (i) { return i.product_id === BALL_PRODUCT_ID; });
          if (ballItem && !hasPlantillas) {
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: ballItem.key, quantity: 0 }),
            }).then(function () {
              try { sessionStorage.setItem("atx_ball_guard_note", "1"); } catch (e) {}
              window.location.reload();
            });
          }
        })
        .catch(function (err) { console.warn("[atx:cartGuard]", err); });
    }

    if (typeof subscribe === "function" && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { enforce(); });
    }
    enforce();
  }

  function initCartUpsell() {
    if (document.body.dataset.atxUpsellBound) return;
    document.body.dataset.atxUpsellBound = "1";

    document.addEventListener("click", function (e) {
      var swatch = e.target.closest("[data-atx-upsell-color]");
      if (swatch) {
        var card = swatch.closest("[data-atx-cart-upsell]");
        if (!card) return;
        $$("[data-atx-upsell-color]", card).forEach(function (s) { s.classList.toggle("is-active", s === swatch); });
        var priceEl = card.querySelector("[data-atx-upsell-price]");
        if (priceEl && swatch.dataset.atxPrice) priceEl.textContent = swatch.dataset.atxPrice;
        var imgEl = card.querySelector("[data-atx-upsell-img]");
        if (imgEl && swatch.dataset.atxUpsellImage) imgEl.src = swatch.dataset.atxUpsellImage;
        var addBtnEl = card.querySelector("[data-atx-upsell-add]");
        if (addBtnEl) {
          addBtnEl.dataset.atxUpsellVariantId = swatch.dataset.atxUpsellVariantId;
          if (addBtnEl.dataset.atxLoading !== "1") {
            addBtnEl.disabled = false;
          }
        }
        return;
      }

      var btn = e.target.closest("[data-atx-upsell-add]");
      if (!btn || btn.dataset.atxLoading === "1") return;

      btn.dataset.atxLoading = "1";
      btn.classList.add("is-loading");
      btn.disabled = true;

      var onCartPage = window.location.pathname.replace(/\/$/, "") === (window.routes.cart_url || "/cart").replace(/\/$/, "");
      var cartDrawer = onCartPage ? null : (document.querySelector("cart-notification") || document.querySelector("cart-drawer"));
      var formData = new FormData();
      formData.append("id", btn.dataset.atxUpsellVariantId);
      formData.append("quantity", "1");
      if (cartDrawer && cartDrawer.getSectionsToRender) {
        formData.append(
          "sections",
          cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(",")
        );
        formData.append("sections_url", window.location.pathname);
      }

      atxQueueCartTask(function () {
        return fetch(window.routes.cart_add_url, {
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
          body: formData,
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) {
              // Shopify devuelve un objeto con "status" (422, etc.) cuando el
              // añadido falla (p. ej. sin stock) — no seguir como si hubiera ido bien.
              throw new Error(response.description || response.message || "No se pudo añadir");
            }
            if (cartDrawer && typeof cartDrawer.renderContents === "function") {
              if (cartDrawer.classList.contains("is-empty")) cartDrawer.classList.remove("is-empty");
              cartDrawer.renderContents(response);
            } else {
              window.location.reload();
            }
          })
          .catch(function (err) {
            console.warn("[atx:cartUpsell]", err);
            btn.classList.remove("is-loading");
            btn.title = "No disponible ahora mismo";
            btn.disabled = true;
          });
      });
    });
  }

  function boot() {
    safe(initPopup, "popup");
    safe(initCartUpsell, "cartUpsell");
    safe(initCartGuard, "cartGuard");
    safe(initScrollProgress, "scrollProgress");
    safe(initReveals, "reveals");
    safe(initTilt, "tilt");
    safe(initMagnetic, "magnetic");
    safe(initCountUp, "countup");
    safe(initGallery, "gallery");
    safe(initVariantPicker, "variantPicker");
    safe(initSizePills, "sizePills");
    safe(initBundleSizes, "bundleSizes");
    safe(initTallaAutofill, "tallaAutofill");
    safe(initSizeGuide, "sizeGuide");
    safe(initAjaxProductForm, "ajaxProductForm");
    safe(initStickyBuy, "stickyBuy");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
